module.exports = __webpack_public_path__ + "static/media/logo.fe4535d4.png";